import React, { useState, useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import {
    Box,
    Grid,
    Button,
    Tooltip,
    Typography,
    Paper
} from "@mui/material";
import { AddCircleOutlineOutlined } from "@mui/icons-material";
import { Link } from "react-router-dom";

import { getRequest } from "Includes/api/apicall";
import { GET_URL } from "Includes/urls";
import { Actions } from "Constants/permissions";

function AcademicYearList(props) {
    const [academicYearList, setAcademicYearList] = useState([]);
    const [rowCount, setRowCount] = useState(0);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(10);

    useEffect(() => {
        getAcademicYearList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page, pageSize]);

    const getAcademicYearList = () => {
        setLoading(true);
        const url = GET_URL.academicyear.api;
        const params = {
            limit: pageSize,
            pageno: page + 1,
        };
        getRequest(url, params, props)
            .then((response) => {
                if (response && response.status === 200) {
                    const data = response.data.data || [];
                    setAcademicYearList(data);
                    setRowCount(response.data?.count || data.length);
                }
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
            });
    };

    const columns = [
        {
            field: "id",
            headerName: "ID",
            width: 90
        },
        {
            field: "name",
            headerName: "Year",
            flex: 1,
            minWidth: 200,
            renderCell: (params) => {
                const isActive = params.row.is_active;
                return (
                    <Tooltip title={isActive ? "Enabled" : "Disabled"}>
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                            <Box
                                sx={{
                                    width: 10,
                                    height: 10,
                                    borderRadius: "50%",
                                    mr: 1.5,
                                    backgroundColor: isActive ? "#4caf50" : "#f44336"
                                }}
                            />
                            <Typography
                                sx={{
                                    opacity: isActive ? 1 : 0.5,
                                    fontWeight: 500
                                }}
                            >
                                {params.value}
                            </Typography>
                        </Box>
                    </Tooltip>
                );
            }
        },
        {
            field: "code",
            headerName: "Code",
            flex: 1,
            minWidth: 200
        }
    ];

    return (
        <Box sx={{ p: 3 }}>

            {/* 🔥 HEADER */}
            <Grid container alignItems="center">
                <Grid item xs={12} md={6}>
                    <Typography variant="h5" fontWeight={600}>
                        Academic Year
                    </Typography>
                </Grid>

                <Grid item xs={12} md={6} textAlign="right">
                    <Button
                        variant="contained"
                        component={Link}
                        to={Actions.academic_year?.create?.url || "/academic-year/create"}
                        startIcon={<AddCircleOutlineOutlined />}
                        sx={{
                            borderRadius: 2,
                            textTransform: "none",
                            px: 2,
                            py: 1,
                            boxShadow: "0 4px 14px rgba(0,0,0,0.1)"
                        }}
                    >
                        {Actions.academic_year?.create?.label || "Add Academic Year"}
                    </Button>
                </Grid>
            </Grid>

            {/* 🔥 TABLE CARD */}
            <Paper
                sx={{
                    mt: 3,
                    p: 2,
                    borderRadius: 3,
                    boxShadow: "0 4px 20px rgba(0,0,0,0.05)"
                }}
            >
                <DataGrid
                    rows={academicYearList}
                    columns={columns}
                    loading={loading}
                    autoHeight
                    rowHeight={44}
                    pagination
                    paginationMode="server"
                    page={page}
                    pageSize={pageSize}
                    onPageChange={(nextPage) => setPage(nextPage)}
                    onPageSizeChange={(nextPageSize) => {
                        setPageSize(nextPageSize);
                        setPage(0);
                    }}
                    pageSizeOptions={[10, 20, 50]}
                    rowCount={rowCount}
                    initialState={{
                        columns: {
                            columnVisibilityModel: {
                                id: false,
                            },
                        },
                    }}
                    disableRowSelectionOnClick
                    sx={{
                        border: "none",
                        "& .MuiDataGrid-columnHeaders": {
                            backgroundColor: "#f5f7fb",
                            fontWeight: 600,
                        },
                        "& .MuiDataGrid-row:hover": {
                            backgroundColor: "#fafafa",
                        },
                        "& .MuiDataGrid-cell": {
                            borderBottom: "1px solid #f0f0f0",
                        }
                    }}
                />
            </Paper>

        </Box>
    );
}

export default AcademicYearList;